<template>
  <div class="file-upload-details">
    <section class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns" style="margin-top: 16px">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ pageTitle }}</p>
                  </header>
                </div>
              </div>
              <div class="columns" style="margin-top: 16px; margin-left: 0">
                <div class="column is-full">
                  <b-field required :label="$t('duplicate-logs-details-view.source-date-title')">
                    <b-datepicker
                        :mobile-native="false"
                        v-model="sourceDate"
                        :placeholder="$t('duplicate-logs-details-view.source-date-title')"
                        icon="calendar-today"
                        locale="fr-FR"
                        show-week-number
                        :disabled="true"
                        :editable="false"
                        @input="sourceDateSelectClicked">
                    </b-datepicker>
                  </b-field>
                  <b-field required :label="$t('duplicate-logs-details-view.destination-date-title')">
                    <b-datepicker
                        :mobile-native="false"
                        v-model="destinationDate"
                        :placeholder="$t('duplicate-logs-details-view.destination-date-title')"
                        icon="calendar-today"
                        locale="fr-FR"
                        show-week-number
                        @input="destinationDateSelectClicked">
                    </b-datepicker>
                  </b-field>
                </div>
              </div>
              <div class="column">
                <span class="is-size-6">{{ $t('duplicate-logs-details-view.more-info-text') }}</span><br/>
              </div>
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column is-narrow">
                  <b-button class="button" @click="cancelClicked" icon-left="close-thick" tabindex="31">
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
                <div class="column is-narrow">
                  <b-button v-if="currentUserAccess('ProjectFilesDetails', this.UserActions.UPDATE, this.project_id)"
                            class="button is-primary" @click="duplicateAllLogs" icon-left="content-duplicate" tabindex="32">
                    {{ $t('duplicate-logs-details-view.duplicate-now-button') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

import firebase from "firebase/app";

export default {
  name: "DuplicateLogsDetails",
  props: {
    'project_id': {
      type: String
    },
    'passed_source_date': {
      type: Date
    }
  },
  data() {
    return {
      sourceDate: this.passed_source_date,
      destinationDate: new Date(),
      isLoading: false
    }
  },
  methods: {
    sourceDateSelectClicked: function (date) {
      this.sourceDate = date;
    },
    destinationDateSelectClicked: function (date) {
      this.destinationDate = date;
    },
    duplicateAllLogs: function () {
      this.isLoading = true;
      const sourceIsoDateString = this.convertToIso(this.sourceDate);
      const destinationIsoDateString = this.convertToIso(this.destinationDate);
      const functions = firebase.app().functions("europe-west3");
      const duplicateLogsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      duplicateLogsFunction({action: "copy_logs", document_id: this.project_id, from: sourceIsoDateString, to: destinationIsoDateString})
          .then((result) => {
            this.isLoading = false;
            const data = result.data;
            if (data.failed > 0 && Array.isArray(data.errors)) {
              let message = `${this.$t('duplicate-logs-details-view.duplicate-report-successful', { count: data.successful })}\n`;
              message += `${this.$t('duplicate-logs-details-view.duplicate-report-failed', { count: data.failed })}\n`;
              message += this.$t('duplicate-logs-details-view.duplicate-report-errors') + ':\n';
              const uniqueErrorMessages = new Set();
              data.errors.forEach((err) => {
                let errorMsg = err.error;
                if (errorMsg === 'NoEstimationFound()') {
                  errorMsg = this.$t('duplicate-logs-details-view.error-NoEstimationFound');
                } else if (errorMsg === 'LogPriorToEstimationError()') {
                  errorMsg = this.$t('duplicate-logs-details-view.error-LogPriorToEstimationError');
                }
                uniqueErrorMessages.add(errorMsg);
              });
              uniqueErrorMessages.forEach((msg) => {
                message += `- ${msg}\n`;
              });
              this.$buefy.dialog.alert({
                title: this.$t('duplicate-logs-details-view.title').toString(),
                message: message.replace(/\n/g, '<br>'),
                type: 'is-warning',
                hasIcon: true,
                icon: 'alert',
                confirmText: this.$t('common.ok').toString(),
              });
            } else {
              const message = this.$t('duplicate-logs-details-view.duplicate-report-successful', { count: data.successful });
              this.showSuccess(message);
            }
            this.$emit('logsDuplicated');
          })
          .catch((error) => {
            this.isLoading = false;
            this.showError(this.$t('duplicate-logs-details-view.common-error') + "\n" + error.message)
            console.log("Error copy_logs: ", error);
          });
    },
    convertToIso: function (dateToConvert) {
      // Extract the year, month, and day components
      const year = dateToConvert.getFullYear();
      const month = String(dateToConvert.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(dateToConvert.getDate()).padStart(2, '0');
      // Construct the ISO date string without the time
      const isoDateString = `${year}-${month}-${day}` + 'T00:00:00Z';
      console.log("converted iso:" + isoDateString); // Outputs: YYYY-MM-DD
      return isoDateString
    },
    /*
     UI Events
     */
    cancelClicked: function () {
      this.$emit('close');
    }
  },
  computed: {
    pageTitle() {
      return this.$t('duplicate-logs-details-view.title')
    }
  }
};
</script>
